import * as React from 'react';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { IconButton } from '@mui/material';

const CustomInfoButton = ({ msg, color = '#622FEE' }) => {
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <Tooltip
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={msg}
          slotProps={{
            popper: {
              disablePortal: true,
            },
          }}
          arrow
          placement="top"
        >
          <IconButton
            aria-label="info"
            onClick={handleTooltipOpen}
            size="small"
            sx={{
              padding: '2px',
              width: '20px',
              height: '20px',
            }}
          >
            <InfoIcon sx={{ fontSize: '14px', color }} />
          </IconButton>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default CustomInfoButton;
